import { InjectionToken, ElementRef } from '@angular/core';

export const ERROR_OVERLAY_DATA = new InjectionToken<any>('ERROR_OVERLAY_DATA');

export interface ErrorOverlayConfig {
  panelClass?: string;
  hasBackdrop?: boolean;
  backdropClass?: string;
  data?: any;
  elementRef?: ElementRef | HTMLElement | null;
  isBrowser?: boolean;
}
